export default function PrivacyPolicyPage() {
  return (
    <div className="w-full">
      <div className="flex items-start justify-center">
        <h1 className="text-center text-4xl max-md:text-3xl">
          End User License Agreement
        </h1>
      </div>
      <div className="m-auto max-w-[800px] px-4">
        <p className="mb-2">
          This End User License Agreement (“Agreement”) is between you and Roll
          Call 2 and governs use of this app made available through the Apple
          App Store. By installing the Roll Call 2 App, you agree to be bound by
          this Agreement and understand that there is no tolerance for
          objectionable content. If you do not agree with the terms and
          conditions of this Agreement, you are not entitled to use the Roll
          Call 2 App.
        </p>
        <ol>
          <li className="mb-2">
            1. Parties - This Agreement is between you and Roll Call 2 only, and
            not Apple, Inc. (“Apple”). Notwithstanding the foregoing, you
            acknowledge that Apple and its subsidiaries are third party
            beneficiaries of this Agreement and Apple has the right to enforce
            this Agreement against you. Roll Call 2, not Apple, is solely
            responsible for the Roll Call 2 App and its content.
          </li>
          <li className="mb-2">
            2. Limited License Roll Call 2 grants you a limited, non-exclusive,
            non-transferable, revocable license to use the Roll Call 2 App. You
            may only use the Roll Call 2 App on Apple devices that you own or
            control and as permitted by the App Store Terms of Service.
          </li>
          <li className="mb-2">
            3. Maintenance and Support - Roll Call 2 does provide minimal
            maintenance or support for it but not to the extent that any
            maintenance or support is required by applicable law, Roll Call 2,
            not Apple, shall be obligated to furnish any such maintenance or
            support.
          </li>
          <li className="mb-2">
            4. Warranty - Roll Call 2 disclaims all warranties about the Roll
            Call 2 App to the fullest extent permitted by law. To the extent any
            warranty exists under law that cannot be disclaimed, Roll Call 2,
            not Apple, shall be solely responsible for such warranty.
          </li>
          <li className="mb-2">
            5. Product Claims - Roll Call 2, not Apple, is responsible for
            addressing any claims by you relating to the Roll Call 2 App or use
            of it, including, but not limited to: (i) any product liability
            claim; (ii) any claim that the Roll Call 2 App fails to conform to
            any applicable legal or regulatory requirement; and (iii) any claim
            arising under consumer protection or similar legislation. Nothing in
            this Agreement shall be deemed an admission that you may have such
            claims.
          </li>
          <li className="mb-2">
            6. Third Party Intellectual Property Claims - Roll Call 2 shall not
            be obligated to indemnify or defend you with respect to any third
            party claim arising out or relating to the Roll Call 2 App. To the
            extent Roll Call 2 is required to provide indemnification by
            applicable law, Roll Call 2, not Apple, shall be solely responsible
            for the investigation, defense, settlement and discharge of any
            claim that the Roll Call 2 App or your use of it infringes any third
            party intellectual property right.6. Third Party Intellectual
            Property Claims - Roll Call 2 shall not be obligated to indemnify or
            defend you with respect to any third party claim arising out or
            relating to the Roll Call 2 App. To the extent Roll Call 2 is
            required to provide indemnification by applicable law, Roll Call 2,
            not Apple, shall be solely responsible for the investigation,
            defense, settlement and discharge of any claim that the Roll Call 2
            App or your use of it infringes any third party intellectual
            property right.
          </li>
          <li className="mb-2">
            7. Legal Compliance - You represent and warrant that: (i) you are
            not located in a country that is subject to a U.S. Government
            embargo, or that has been designated by the U.S. Government as a
            “terrorist supporting” country; and (ii) you are not listed on any
            U.S. Government list of prohibited or restricted parties.
          </li>
          <li className="mb-2">
            8. Developer - Brandon Lehr PO Box 6, Bloomingburg, OH 43106 - If
            you have any questions or suggestions about my Terms and Conditions,
            do not hesitate to contact me at blehr.mail@gmail.com.
          </li>
          <li className="mb-2">
            9. Third Party Terms of Agreement - You must comply with applicable
            third party terms of agreement when using Roll Call 2 (e.g. your
            wireless data service agreement).
          </li>
          <li className="mb-2">
            10. Third Party Beneficiary - Apple, and Apple&apos;s subsidiaries,
            are third party beneficiaries of this EULA, and that, upon the your
            acceptance of the terms and conditions of this EULA, Apple will have
            the right (and will be deemed to have accepted the right) to enforce
            this EULA against you as a third party beneficiary thereof.
          </li>
        </ol>
        <p className="mb-2">
          I may update our Terms and Conditions from time to time. Thus, you are
          advised to review this page periodically for any changes. I will
          notify you of any changes by posting the new Terms and Conditions on
          this page. These changes are effective immediately after they are
          posted on this page.
        </p>
      </div>
    </div>
  );
}
